import React from 'react'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { Avatar } from '@deal/components'
import { RecommendingExpertsFragment } from '#src/generated/graphql'
import styles from './styles.css'

interface ExpertsFacepile {
  experts: RecommendingExpertsFragment[]
  displayTreshold: number
  avatarSize?: number
  totalExperts?: number
  className?: string
}

const ExpertsFacepile: React.SFC<ExpertsFacepile> = ({
  experts,
  totalExperts,
  avatarSize = 24,
  displayTreshold,
  className
}) => {
  return (
    <div className={classNames(styles.experts, className)}>
      {experts.slice(0, displayTreshold).map(expert => {
        return (
          <Link to={`/experts/${expert.vanityId || expert.id}`} key={expert.id}>
            <Avatar
              name={expert.displayName}
              size={avatarSize}
              src={
                (expert.expertProfile &&
                  expert.expertProfile.profilePhoto &&
                  expert.expertProfile.profilePhoto.url) ||
                undefined
              }
              className={styles.expertAvatar}
            />
          </Link>
        )
      })}
      {totalExperts && experts.length > displayTreshold && (
        <Avatar
          name={`+${totalExperts - displayTreshold}`}
          trimNameToInitials={false}
          size={24}
          className={styles.expertAvatar}
        />
      )}
    </div>
  )
}

export default ExpertsFacepile
